require('./image');
require('./hotspots');